<template>
    <div class="watchdog-tabs mb-0 px-5 mt-3">
         <button v-for="type in types"
            :class="['watchdog-tab-btn', { active: selectedType === type }]"
            @click="selectedType = type"
        >
            {{ $t("autoscreening.types." + type) }}
            <span class="badge bg-secondary px-2 py-1 me-2 mt-1 rounded-pill" style="position: relative; top: -1.5px; right: -8px">
            {{ formattedAutoscreeningCounts[type] ?? 0 }}
            </span>
        </button>
    </div>
    <div class="watchdog-wrapper-box p-5">
        <div class="mb-5 pt-1 d-flex align-items-center">
            <label class="mb-1 fw-semibold px-1 pt-1">{{ $t("autoscreening.search") }}:</label>
            <input class="form-control px-3 ms-2 mx-1" v-model="filter.query"
                :placeholder="$t('autoscreening.filter.placeholder.' + selectedType)">
        </div>
        <div class="w-100 table-responsive-lg px-1">
            <table class="w-100 mb-5 watchdog_table table" v-if="selectedType == 'person'">
                <tr class="table_row align-items-center" v-for="autoscreening in autoscreenings"
                    :class="{ watchdog_disabled: !autoscreening.enabled }">
                    <td colspan="8" class="text-start">
                        <a :href="'/person/' + autoscreening.hash"  target="_blank">
                            {{ autoscreening.name }}
                        </a>
                        <br>
                        <span v-if="autoscreening.birthdate">{{ $t("autoscreening.birthdate") }}: {{ format_date(autoscreening.birthdate) }}</span>
                        <span v-else>{{ $t("autoscreening.birthdate") }}: ---</span>
                        <br>
                        <span>{{ $t("autoscreening.countries") }}: {{ autoscreening.countries }}</span>
                        <br>
                        <span>
                            <span v-for="(source, index) in autoscreening.sources" class="badge bg-secondary px-2 py-1 me-2 mt-1 rounded-pill">
                                {{ $t("autoscreening.sources." + source) }}
                            </span>
                        </span>
                        <br>
                        <span class="watchdog_created">
                            {{ $t("autoscreening.createdAt") }} {{ format_date(autoscreening.created) }},
                            {{ $t("autoscreening.createdBy") }}
                            {{ autoscreening.created_by || $t("autoscreening.systemCreated") }}
                        </span>
                    </td>
                    <td colspan="3">
                        <div class="d-flex justify-content-start align-items-end flex-column">
                            <!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
                            <div v-for="(flag, i) in autoscreening.flags" v-html="flag" class="autoscreening_flag_bubble"
                            :class="{'mb-2': (i <  autoscreening.flags.length - 1)}">
                            </div>
                            <i class="mt-1 text-nowrap">
                                {{ $t("autoscreening.stateDate") }} {{ format_datetime(autoscreening.state_date) }}
                            </i>
                        </div>
                    </td>
                    <td colspan="1" class="text-end">
                        <div class="form-check form-switch d-inline-block m-0 cursor_pointer"
                            data-bs-toggle="modal" data-bs-target="#togglePopup"
                            @click="toggleAutoscreening = autoscreening">
                            <input class="form-check-input cursor_pointer" type="checkbox" role="switch"
                                :checked="autoscreening.enabled" @click.prevent>
                        </div>
                        <div v-if="!autoscreening.enabled" class="badge bg-secondary px-2 py-1 mt-1 rounded-pill">
                            {{ $t("autoscreening.disabledBadge") }}
                        </div>
                    </td>
                </tr>
            </table>
            <table class="w-100 mb-5 watchdog_table table" v-if="['cz', 'sk'].includes(selectedType)">
                <tr class="table_row align-items-center" v-for="autoscreening in autoscreenings"
                    :class="{ watchdog_disabled: !autoscreening.enabled }">
                    <td colspan="8" class="text-start">
                        <a :href="'/subject/' + autoscreening.source_country + '/id/' + autoscreening.url_identifier" target="_blank">
                            {{ autoscreening.name }}
                        </a>
                        <br>
                        <span>IČO: {{ autoscreening.identifier }}</span>
                        <br>
                        <span>
                            <span v-for="(source, index) in autoscreening.sources" class="badge bg-secondary px-2 py-1 me-2 mt-1 rounded-pill">
                                {{ $t("autoscreening.sources." + source) }}
                            </span>
                        </span>
                        <br>
                        <span class="watchdog_created">
                            {{ $t("autoscreening.createdAt") }} {{ format_date(autoscreening.created) }},
                            {{ $t("autoscreening.createdBy") }}
                            {{ autoscreening.created_by || $t("autoscreening.systemCreated") }}
                        </span>
                    </td>
                    <td colspan="3">
                        <div class="d-flex justify-content-start align-items-end flex-column">
                            <!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
                            <div v-for="(flag, i) in autoscreening.flags" v-html="flag"
                            class="autoscreening_flag_bubble"
                            :class="{'mb-2': (i <  autoscreening.flags.length - 1)}">
                            </div>
                            <i class="mt-1 text-nowrap">
                                {{ $t("autoscreening.stateDate") }} {{ format_datetime(autoscreening.state_date) }}
                            </i>
                        </div>
                    </td>
                    <td colspan="1" class="text-end">
                        <div class="form-check form-switch d-inline-block m-0 cursor_pointer"
                            data-bs-toggle="modal" data-bs-target="#togglePopup"
                            @click="toggleAutoscreening = autoscreening">
                            <input class="form-check-input cursor_pointer" type="checkbox" role="switch"
                                :checked="autoscreening.enabled" @click.prevent>
                        </div>
                        <div v-if="!autoscreening.enabled" class="badge bg-secondary px-2 py-1 mt-1 rounded-pill">
                            {{ $t("autoscreening.disabledBadge") }}
                        </div>
                    </td>
                </tr>
            </table>
            <table class="w-100 mb-5 watchdog_table table" v-if="selectedType == 'international'">
                <tr class="table_row align-items-center" v-for="autoscreening in autoscreenings"
                    :class="{ watchdog_disabled: !autoscreening.enabled }">
                    <td colspan="4" class="text-start">
                        <a :href="'/subject/opening/' + autoscreening.identifier" target="_blank">
                            {{ autoscreening.name }}
                        </a>
                        <br>
                        <span>BVD ID: {{ autoscreening.identifier }}</span>
                        <br>
                        <span>
                            <span v-for="(source, index) in autoscreening.sources" class="badge bg-secondary px-2 py-1 me-2 mt-1 rounded-pill">
                                {{ $t("autoscreening.sources." + source) }}
                            </span>
                        </span>
                        <br>
                        <span class="watchdog_created">
                            {{ $t("autoscreening.createdAt") }} {{ format_date(autoscreening.created) }},
                            {{ $t("autoscreening.createdBy") }}
                            {{ autoscreening.created_by || $t("autoscreening.systemCreated") }}
                        </span>
                    </td>
                    <td colspan="2" class="text-start">
                        <div class="d-flex align-items-start">
                            <div class="me-1 pe-1 text-nowrap">
                                <div>
                                    <span v-if="autoscreening.active_to">
                                        {{ $t("autoscreening.activeTo") }}
                                    </span>
                                    <span v-else>---</span>
                                </div>
                                <div v-if="autoscreening.active_to">
                                    {{ $t("autoscreening.reactivate") }}
                                </div>
                            </div>
                            <div class="value-col">
                                <div>
                                    <span v-if="autoscreening.active_to">
                                        {{ format_date(autoscreening.active_to) }}
                                    </span>
                                    <span v-else>---</span>
                                </div>
                                <div v-if="autoscreening.active_to" class="cursor_pointer"
                                    data-bs-toggle="modal" data-bs-target="#reactivationPopup"
                                    @click="reactivationAutoscreening = autoscreening">
                                    <span v-if="autoscreening.reactivate">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                            viewBox="0 0 24 24" fill="none" stroke="#4A9200"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="icon icon-tabler icons-tabler-outline icon-tabler-checkbox align-icon">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M9 11l3 3l8 -8" />
                                            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
                                        </svg>
                                    </span>
                                    <span v-else>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                            viewBox="0 0 24 24" fill="none" stroke="#000000"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="icon icon-tabler icons-tabler-outline icon-tabler-square align-icon">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td colspan="3">
                        <div class="d-flex justify-content-start align-items-end flex-column">
                            <!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
                            <div v-for="(flag, i) in autoscreening.flags" v-html="flag"
                                class="autoscreening_flag_bubble"
                                :class="{'mb-2': (i <  autoscreening.flags.length - 1)}">
                            </div>
                            <i class="mt-1 text-nowrap">
                                {{ $t("autoscreening.stateDate") }} {{ format_datetime(autoscreening.state_date) }}
                            </i>
                        </div>
                    </td>
                    <td colspan="1" class="text-end">
                        <div class="form-check form-switch d-inline-block m-0 cursor_pointer"
                            data-bs-toggle="modal" data-bs-target="#togglePopup"
                            @click="toggleAutoscreening = autoscreening">
                            <input class="form-check-input cursor_pointer" type="checkbox" role="switch"
                                :checked="autoscreening.enabled" @click.prevent>
                        </div>
                        <div v-if="!autoscreening.enabled" class="badge bg-secondary px-2 py-1 mt-1 rounded-pill">
                            {{ $t("autoscreening.disabledBadge") }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div v-if="isLoading" class="text-center mb-5 pb-4">
            <div class="spinner-border" role="status" aria-label="Loading"></div>
        </div>
        <div v-if="!isLoading && !count" class="text-center mb-5 pb-4">
           <p>{{ $t("autoscreening.empty") }}</p>
        </div>
        <div class="row paginator">
            <div class="col-3 px-3">
                <select name="page_autoscreening" v-model="perPage" class="form-select w-75" >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="1000">1000</option>
                </select>
            </div>
            <div class="col-6 text-center">
                <button class="btn watchdog_page_button mx-1" @click="setPage(minPage)" v-if="minPage != page"><<</button>
                <button class="btn watchdog_page_button mx-1" @click="setPage(page - 1)" v-if="previousPage != page"><</button>
                <button class="btn watchdog_page_button mx-1" @click="setPage(page + 1)" v-if="nextPage != page">></button>
                <button class="btn watchdog_page_button mx-1" @click="setPage(maxPage)" v-if="maxPage != page">>></button>
            </div>
            <div class="col-3 text-end mt-2 pe-3">
                <span>{{ $t("autoscreening.page", {page: page, maxPage: maxPage}) }}</span>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="reactivationPopup" tabindex="-1" aria-labelledby="reactivationPopupLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="reactivationPopupLabel">{{ $t("autoscreening.prolongationPopup") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-start">
            <p class="mb-0" v-if="reactivationAutoscreening.reactivate">{{ $t("autoscreening.paragraphStopReactivating") }}</p>
            <p class="mb-0" v-else>{{ $t("autoscreening.paragraphReactivating") }}</p>
        </div>
        <div class="modal-footer">
            <button v-if="reactivationAutoscreening.reactivate" class="btn btn-primary" data-bs-dismiss="modal" @click="stopReactivation(reactivationAutoscreening.id)">{{ $t("autoscreening.dontReactivate") }}</button>
            <button v-else class="btn btn-primary" data-bs-dismiss="modal" @click="reactivation(reactivationAutoscreening.id)">{{ $t("autoscreening.reactivateAgain") }}</button>
        </div>

        </div>
    </div>
    </div>

    <div class="modal fade" id="togglePopup" tabindex="-1" aria-labelledby="togglePopupLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="togglePopupLabel">{{ $t("autoscreening.togglePopup") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-start">
            <p class="mb-0" v-if="toggleAutoscreening.enabled">{{ $t("autoscreening.paragraphDisabling") }}</p>
            <p class="mb-0" v-else>{{ $t("autoscreening.paragraphEnabling") }}</p>
        </div>
        <div class="modal-footer">
            <button v-if="toggleAutoscreening.enabled" class="btn btn-primary" data-bs-dismiss="modal" @click="toggleWatchdog(toggleAutoscreening.id, false)">{{ $t("autoscreening.disableWatchdog") }}</button>
            <button v-else class="btn btn-primary" data-bs-dismiss="modal" @click="toggleWatchdog(toggleAutoscreening.id, true)">{{ $t("autoscreening.enableWatchdog") }}</button>
        </div>

        </div>
    </div>
    </div>

</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from "axios";
import moment from 'moment'

const api = axios.create({
    baseURL: "",
    withCredentials: true,
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken"
});

export default {
    components: {
        Multiselect
    },
    data() {
        return {
            autoscreenings: [],
            autoscreeningCounts: {
            cz: 0,
            sk: 0,
            international: 0,
            person: 0
            },
            institution: null,
            reactivationAutoscreening: {
                reactivate: null,
                id: null
            },
            toggleAutoscreening: {
                enabled: null,
                id: null
            },
            filter: {
                query: null,
                hasRisk: null
            },
            page: 1,
            count: 0,
            perPage: 20,
            isLoading: false,
            cancelToken: null,
            searchTimer: null,
            debounceTime: 700,
            type: null,
            selectedType: "cz",
            types: ['cz', 'sk', 'international', 'person']
        }
    },
    mounted: function () {
        if (document.getElementById("language")) {
            this.$i18n.locale = document.getElementById("language").innerText;
        }
        if (document.getElementById("institution")) {
            this.institution = document.getElementById("institution").innerText.replace(",", "");
        }
        if (document.getElementById("autoscreenings_type")) {
            this.type = document.getElementById("autoscreenings_type").innerText;
        }
        if (document.getElementById("autoscreenings_types")) {
            this.types = document.getElementById("autoscreenings_types").innerText.split(",");
            if (this.types.length) {
                this.selectedType = this.types[0];
            }
            else {
                this.selectedType = null;
            }
        }
        this.searchAutoscreenings();
    },
    computed: {
        maxPage: function () {
            return Math.ceil(this.count/this.perPage)
        },
        minPage: function () {
            return 1
        },
        previousPage: function () {
            if (this.page == this.minPage) {
                return this.minPage;
            }
            return this.page - 1;
        },
        nextPage: function () {
            if (this.page == this.maxPage) {
                return this.maxPage;
            }
            return this.page + 1;
        },
        formattedAutoscreeningCounts() {
            const out = {};
            for (const t of this.types) {
            out[t] = this.formatCountTis(this.autoscreeningCounts?.[t] ?? 0);
            }
            return out;
        }
    },
    watch: {
        filter: {
            handler() {
                this.page = 1;
                this.searchAutoscreenings();
            },
            deep: true,
            immediate: true
        },
        page: function () {
            this.searchAutoscreenings();
        },
        perPage: function () {
            this.page = 1;
            this.searchAutoscreenings();
        },
        selectedType: function () {
            this.page = 1;
            this.filter.query = "";
            this.searchAutoscreenings();
        },
    },
    methods: {
        format_date(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY')
            }
            else {
                return "-"
            }
        },
        format_datetime(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm')
            }
        },
        setPage: function (page) {
            this.page = page;
        },
        searchAutoscreenings: function () {
            var query = this.filter.query;
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }

            if (this.cancelToken != null) {
                this.cancelToken.cancel("Operation canceled by the user.");
                this.cancelToken = null;
            }

            this.isLoading = true;
            this.autoscreenings = [];
            this.actualString = query;

            let params = {
                q: query,
                per_page: this.perPage,
                page: this.page,
                selected_type: this.selectedType
            }

            this.searchTimer = setTimeout(function () {
                this.cancelToken = axios.CancelToken.source();
                var url = ""
                if (this.type == "admin") {
                    url = "/adminsite/api/autoscreenings/" + this.institution;
                }
                else {
                    url = "/api/autoscreenings";
                }
                api.get(url, { params: params, cancelToken: this.cancelToken.token })
                    .then(function (r) {
                        if (query == this.actualString) {
                            this.autoscreenings = r.data.items;
                            this.count = r.data.count;
                            this.autoscreeningCounts = r.data.types_counts || this.autoscreeningCounts;
                        }
                    }.bind(this))
                    .catch(e => {
                        if (axios.isCancel(e)) {
                            console.log("Request canceled", e.message);
                        } else {
                            console.log(e);
                        }
                    })
                    .finally(() => {
                        this.cancelToken = null;
                        if (query == this.actualString) {
                            this.isLoading = false;
                        }
                    })
            }.bind(this), this.debounceTime);
        },
        stopReactivation: function (autoscreening_id) {
            let params = {
                selected_type: this.selectedType,
                autoscreening_id: autoscreening_id
            }

            var url = ""
            if (this.type == "admin") {
                url = "/adminsite/api/autoscreenings/" + this.institution + "/stop/reactivate";
            }
            else {
                url = "/api/autoscreening/stop/reactivate";
            }
            api.get(url, { params: params })
                .finally(() => {
                    this.searchAutoscreenings();
                })
        },
        reactivation: function (autoscreening_id) {
            let params = {
                selected_type: this.selectedType,
                autoscreening_id: autoscreening_id
            }

            var url = ""
            if (this.type == "admin") {
                url = "/adminsite/api/autoscreenings/" + this.institution + "/reactivate";
            }
            else {
                url = "/api/autoscreening/reactivate";
            }
            api.get(url, { params: params })
                .finally(() => {
                    this.searchAutoscreenings();
                })
        },
        toggleWatchdog: function (autoscreening_id, enabled) {
            let params = {
                selected_type: this.selectedType,
                autoscreening_id: autoscreening_id,
                enabled: enabled
            }

            var url = ""
            if (this.type == "admin") {
                url = "/adminsite/api/autoscreenings/" + this.institution + "/toggle";
            }
            else {
                url = "/api/autoscreening/toggle";
            }
            api.get(url, { params: params })
                .finally(() => {
                    this.searchAutoscreenings();
                })
        },
        formatCountTis(value) {
            const n = Number(value) || 0;

            // under thousand - normal
            if (n < 1000) {
                return n.toString();
            }

            // thousands - only tis., no hundreds
            if (n < 1_000_000) {
                const thousands = Math.floor(n / 1000);
                return `${thousands} tis.`;
            }

            // millions - with thousands, e.g. 1,6 mil.
            return new Intl.NumberFormat("cs-CZ", {
                notation: "compact",
                compactDisplay: "short",
                maximumFractionDigits: 1
            }).format(n);
        }
    }
}
</script>

<style scoped>
.watchdog_disabled td {
    opacity: 0.55;
}

.watchdog_disabled td:last-child {
    opacity: 1;
}

.watchdog_created {
    font-size: 0.85em;
}
</style>
